import React from 'react';
import './search-filters.scss';

const SearchFilters = props => <div className="search-filters">{props.children}</div>;
export default SearchFilters;